/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import React from 'react';

import { ListeContainer, useListe } from '@mairistem/liste';

import type { Diplome } from '@/types';

import DiplomeListe from './DiplomeListe';

interface Props {
  /** Callback appelé lors de la sauvegarde (liste en saisie) */
  onSave?: (qualification: Diplome) => void;
  /** Callback appelé lors de la sélection d'une ligne */
  onSelect?: (qualification: Diplome) => void;
  /** Diplôme sélectionné */
  selectedItem?: Diplome;
  /** Callback appelé lors du reset de l'item */
  resetSelectedItem?: (qualification: Diplome) => void;
}

const DiplomeListeContainer = (props: Props) => {
  const {
    selectedItem = {},
    onSave = null,
    onSelect = null,
    resetSelectedItem = null,
  } = props;

  const [service] = useListe('/api/administres/recensement-citoyen/diplomes');

  return (
    <ListeContainer
      service={service}
      type="diplomes"
      contains="liste"
      perPage={50}
    >
      <DiplomeListe
        onSave={onSave}
        onSelect={onSelect}
        selectedDiplome={selectedItem}
        resetSelectedItems={resetSelectedItem}
      />
    </ListeContainer>
  );
};

export default DiplomeListeContainer;
